import brand from "@/assets/images/brand.png";
import usePolyfills from "@/libs/hooks/polyfills";
import { Box, Flex, Image } from "@chakra-ui/react";

const Loading = () => {
  const { getMaxHeightRepresentation } = usePolyfills();
  const fullscreen = getMaxHeightRepresentation();
  return (
    <Flex height={fullscreen} bg="#0f0f0f" width="100%">
      <Box m="auto" color="white" fontSize="sm">
        <Image src={brand} width={{ base: 60, md: 96 }} mx="auto" />
      </Box>
    </Flex>
  );
};
export default Loading;
